// sites.$siteId.compare.tsx
// Route : /sites/:siteId/comparison — comparaison inter-versions DUERP d'un site.
// Guide : VERSIONING_FRONTEND_GUIDE §7

import { createFileRoute } from "@tanstack/react-router";

import { DuerpComparisonServerPage } from "@/presentation/pages/DuerpComparisonServerPage";

import { Route as SiteRoute } from "./sites.$siteId";

export const Route = createFileRoute("/sites/$siteId/comparison")({
  component: function DuerpCompareComponent() {
    const { site } = SiteRoute.useLoaderData();
    return <DuerpComparisonServerPage siteId={site.id} siteName={site.name} />;
  },
});
